import "@Styles/Controls/Print/printImageToggle_sm.less";
export default {
  data: function data() {
    return {
      config: {},
      isHidden: false,
      buttonLabel: ''
    };
  },
  methods: {
    init: function init(config) {
      this.config = config || {};
      this.$_setLabelAndClasses();
    },
    toggleImages: function toggleImages() {
      this.isHidden = !this.isHidden;
      this.$_setLabelAndClasses();
    },
    $_setLabelAndClasses: function $_setLabelAndClasses() {
      var parent = this.$_getParentElement();
      var images = parent.getElementsByTagName('img');

      if (images) {
        if (this.isHidden) {
          this.buttonLabel = images.length > 1 ? this.config.showImagesText : this.config.showImageText;

          for (var i = 0; i < images.length; i++) {
            images[i].classList.add('hideFromPrint', 'imageHidden');
          }
        } else {
          this.buttonLabel = images.length > 1 ? this.config.hideImagesText : this.config.hideImageText;

          for (var _i = 0; _i < images.length; _i++) {
            images[_i].classList.remove('hideFromPrint', 'imageHidden');
          }
        }
      }
    },
    $_getParentElement: function $_getParentElement() {
      /* istanbul ignore next */
      return this.$el.parentElement;
    }
  }
};